/*

? First, let's import the interface that will describe the shape of our chat object.

*/

import StateInterface from "../state-interface";

/*

& Now let's describe an initial state for the chat object. This is the state that will be used when the app first fires up. Think of it like a placeholder.

*/

export const home_page_stats: StateInterface["home_page_stats"] = {
    initial_load_done: false,
    listings: {
        total: 0,
    },
    leads: {
        total: 0,
        new: 0,
    },
    boost:{
        active: 0,
        completed: 0,
        expiring: 0,
    },
    broadcast:{
        total: 0,
        unread: 0,
    }
};
